import React from 'react'
import { css } from '@emotion/react'
import { TextBaseProps, TextProps, FontCategory, FontSize } from './types'

export const Text = <T extends React.ElementType = 'p'>({
  as,
  extendedAs,
  fontStyle = 'body-m',
  children,
  className,
  style,
  ...rest
}: TextProps<T>) => {
  const Component: React.ElementType = as || extendedAs || 'p'

  const FontCategory = fontStyle.split('-')[0] as FontCategory
  const FontSize = fontStyle.split('-')[1] as FontSize

  return (
    <Component css={textStyles(FontCategory, FontSize)} className={className} style={style} {...rest}>
      {children}
    </Component>
  )
}

const textStyles = (fontCategory: FontCategory, fontSize: FontSize) => {
  switch (fontCategory) {
    case 'display':
      return css`
        font-family: var(--display-fontFamily);
        font-size: var(--display-${fontSize}-fontSize);
        font-weight: var(--medium);
        line-height: var(--display-${fontSize}-lineHeight);
        letter-spacing: var(--display-${fontSize}-letterSpacing);
      `
    case 'heading':
      return css`
        font-family: var(--heading-fontFamily);
        font-size: var(--heading-${fontSize}-fontSize);
        font-weight: var(--regular);
        line-height: var(--heading-${fontSize}-lineHeight);
        letter-spacing: var(--heading-${fontSize}-letterSpacing);
      `
    case 'body':
      return css`
        font-family: var(--body-fontFamily);
        font-size: var(--body-${fontSize}-fontSize);
        line-height: var(--body-${fontSize}-lineHeight);
        font-weight: var(--regular);
        letter-spacing: var(--body-${fontSize}-letterSpacing);
      `
    case 'label':
      return css`
        font-family: var(--label-fontFamily);
        font-size: var(--label-${fontSize}-fontSize);
        line-height: var(--label-${fontSize}-lineHeight);
        font-weight: var(--regular);
        letter-spacing: var(--label-${fontSize}-letterSpacing);
      `
    case 'iconLabel':
      return css`
        font-family: var(--iconLabel-fontFamily);
        font-size: var(--iconLabel-${fontSize}-fontSize);
        line-height: var(--iconLabel-${fontSize}-lineHeight);
        font-weight: var(--medium);
        letter-spacing: var(--iconLabel-${fontSize}-letterSpacing);
      `
  }
}
